import $fetch from 'lib/fetch';
import { API_BASE_URL, parseResponseData } from '../../utils';
import planResponseSchemas from './plan.responses.schemas';

const BASE_SERVICE_URL = `${API_BASE_URL}/plan` as const;

export async function getAllPlans() {
  const response = await $fetch(`${BASE_SERVICE_URL}/fetchPlans`);

  const data = parseResponseData(response, planResponseSchemas.getAllPlans);

  return data;
}
